/**
 * Tabla scrollable con header fijo
 * 
 * @param columnas: [{style:{width: x%}, nombre:"nombreColumna", dataKey:"dataKey"}]
 * @param datos: [{}]
 */

import { useRef, useEffect, useState } from "react";

const estiloWrapper ={width:"100%", display:"flex", flexDirection:"column", flex:"1"};
const estiloEncabezado={display:"flex", flexDirection:"row", width:"100%", backgroundColor:"#a3cc00", fontWeight:"bold"};
const estiloDatos = {display:"flex", flex:"1 0 10px", flexDirection:"column", width:"100%",  overflow:"auto"};
const estiloFilaDatos = {display:"flex", flexDirection:"row", width:"100%"};

const Tabla=({columnas, datosIni})=> {
    const encabezadoRef = useRef();
    const visorDatosRef = useRef();
    const ordenRef = useRef(null);

    const [datos, setDatos] = useState(datosIni);


    useEffect(()=>{            
        if (visorDatosRef.current.clientHeight < visorDatosRef.current.scrollHeight) {            
            encabezadoRef.current.style.width="calc(100% - 20px)";
        }
    }, [datos]);

    useEffect(()=>{            
        setDatos(datosIni);
    }, [datosIni]);

    const ordenar=(campo, indice) => {         
        if (columnas[indice].tipo && columnas[indice].tipo == "numerico") {
            ordenarNumero(campo, indice)
        } else {
            ordenarTexto(campo, indice)
        }
    }

    const ordenarTexto =(campo, indice) => {  
        let nds = null;
        if (ordenRef.current == 1) {
            nds = [...datos].sort((a, b) =>{
                return 0 - a[campo].localeCompare(b[campo]);
            });
            ordenRef.current = -1;
        } else {           
            nds = [...datos].sort((a, b) =>{
                return a[campo].localeCompare(b[campo]);
            });
            ordenRef.current = 1;            
        }   
        setDatos(nds);     
    }

    const ordenarNumero =(campo, indice) => {     
        let nds = null;
        if (ordenRef.current == 1) {
            nds = [...datos].sort((a, b) =>{
                return 0 - (a[campo]- b[campo]);
            });
            ordenRef.current = -1;
        } else {           
            nds = [...datos].sort((a, b) =>{
                return a[campo]- b[campo];
            });
            ordenRef.current = 1;            
        }   
        setDatos(nds);     
    }
console.log("rendereando")
    return (
        <div style={estiloWrapper}>
            <div style={estiloEncabezado} ref={encabezadoRef}>
                {
                columnas.map((c, index)=>{
                    return (
                        <div style={c.style} onClick={()=>{ordenar(c.dataKey, index)}}>{c.nombre}</div>
                    )
                })
                }
            </div>

            <div style={estiloDatos} ref={visorDatosRef}>
            {
                datos.map((d, index) =>{                                               
                    return (
                        <div style={estiloFilaDatos}>
                        {
                        columnas.map((c, index2)=>{
                            return (
                                <div style={c.style}>
                                    {d[c.dataKey]}
                                </div>        
                            )
                        })
                        }
                        </div>
                    )
                })               
            }
            </div>
        </div>
    )
}

export default Tabla;